/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {LegalEntityParentCompanyDTO} from '../model/LegalEntityParentCompanyDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* LegalEntityParentCompanyService service.
* @module api/LegalEntityParentCompanyServiceApi
* @version v0
*/
export class LegalEntityParentCompanyServiceApi {

    /**
    * Constructs a new LegalEntityParentCompanyServiceApi. 
    * @alias module:api/LegalEntityParentCompanyServiceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getAllLegalEntityParentCompany operation.
     * @callback moduleapi/LegalEntityParentCompanyServiceApi~getAllLegalEntityParentCompanyCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/LegalEntityParentCompanyDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get full Legal Entity hierarchy
     * Request to get the hierarchy and the combinations of the different subsidiaries, companies and regions associated to the parent company.
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.includeHierarchy  (default to <.>)
     * @param {module:api/LegalEntityParentCompanyServiceApi~getAllLegalEntityParentCompanyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllLegalEntityParentCompany(opts, callback) {
      opts = !(opts === null || opts === undefined) ? opts : true;
      console.log("getAllLegalEntityParentCompany opts: ", opts);
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'includeHierarchy': opts
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [LegalEntityParentCompanyDTO];

      return this.apiClient.callApi(
        '/api/legal-entity-parent-company', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}